/* istanbul ignore file */
// TODO: Create test file

import { computed, inject } from 'vue';

export default function useButtonAttributes({
  isBrandData, isSpecialtyData, storeFrontUrl, specialtyId, isEnabled,
}) {
  const widgetName = inject('widgetName');
  const isRegistry = inject('isRegistry');

  const hasContextualWidgetClass = computed(() => {
    switch (widgetName?.value || '') {
    case 'floatingWidget':
      return !!(isEnabled.value && isSpecialtyData.value);
    case 'virtualAdvisorWidget':
      return !!isSpecialtyData.value;
    default:
      return false;
    }
  });

  // if true -> append brand data
  const brandAttributes = computed(() => ({ ...(!!isBrandData.value && { href: storeFrontUrl.value }) }));
  const specialtyAttributes = computed(() => ({
    // if true -> specialty data
    ...(isSpecialtyData.value && {
      'data-specialty-id': specialtyId.value,
      role: 'button',
      ...(!!isRegistry?.value && { 'data-retailer-store-id': 'registry' }),
    }),
  }));

  return {
    // ['a' || 'div']
    tagType: computed(() => (isBrandData.value ? 'a' : 'div')),
    // ['sf-contextual-widget-live-chat-class' || '']
    contextualClass: computed(() => (hasContextualWidgetClass.value ? 'sf-contextual-widget-live-chat-class' : '')),
    // dynamically apply the button attributes
    buttonAttributes: computed(() => ({
      ...brandAttributes.value,
      ...specialtyAttributes.value,
    })),
  };
}
